import { Container, Row, Col } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';
import { leftRightColumns, leftRightSizes, leftRightDefaultColumns } from '../styles';

// types
import type { LeftRightBigProps } from '..';

// utils
import { contentHeadline } from '..';
import { buildSize, gridSizes } from 'utils/gridSize';
import { useIsDesktop, useIsTablet } from 'components/App/SizeProvider';
import { useGroup } from 'utils/hooks/use-group';

export function LeftRight({
  image: Image,
  headline: Headline,
  caption: Caption,
  content: Content,
  link: Link,
  theme,
  imagePosition,
}: Readonly<LeftRightBigProps>) {
  const isTablet = useIsTablet();
  const isDesktop = useIsDesktop();

  let gridColumns =
    leftRightColumns[leftRightSizes[theme][imagePosition]] || leftRightDefaultColumns;

  const isBig = imagePosition.indexOf('_big') > -1;
  let gridWidth = isBig ? 'full' : 'twoThird';
  const isGroup = useGroup();
  let gridWidthOffset = isBig ? 0 : 12.75;

  if (!Image) {
    gridColumns = [4, 8, 12];
  }

  if (isGroup) {
    return (
      <Container maxContentWidth={buildSize(gridSizes[gridWidth], gridWidthOffset)}>
        <Row className={styles.row}>
          <Col size={gridColumns.text}>
            {Headline && <Headline format={contentHeadline[theme]} />}
            {(isDesktop || !isBig) && Content && <Content />}
          </Col>
          {(Image || Caption) && (
            <Col size={gridColumns.image} className={styles.imageWrapper}>
              {Image && <Image />}
              {Caption && <Caption />}
            </Col>
          )}
          {!isDesktop && isBig && <Col size={[4, 8, 12]}>{Content && <Content />}</Col>}
        </Row>
      </Container>
    );
  }

  return (
    <Container maxContentWidth={buildSize(gridSizes['gddsFullGrid'], 0)}>
      <Row className={styles.row}>
        <Col size={gridColumns.text}>
          {(isDesktop || isTablet) && Headline && (
            <Headline className={styles.sublineMargin} format={contentHeadline[theme]} />
          )}
          {(isDesktop || isTablet) && Content && <Content />}
          {Link && (isDesktop || isTablet) && <Link />}
        </Col>
        {(Image || Caption) && (
          <Col size={gridColumns.image} className={styles.imageWrapper}>
            {Image && <Image />}
            {Caption && <Caption />}
          </Col>
        )}
        {((!isDesktop && isBig) || (!isDesktop && !isTablet && Content)) && (
          <Col size={[4, 8, 12]}>
            {Headline && <Headline className={styles.withMargin} format={contentHeadline[theme]} />}
            {Content && <Content />}
            {Link && <Link />}
          </Col>
        )}
      </Row>
    </Container>
  );
}
